var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"res-container"},_vm._l((_vm.items),function(item,index){return _c('div',_vm._g({key:index,staticClass:"res-column bg",class:item.class,style:([
        {
          'background-image':
            item.gradiant +
            ', url(' +
            require('@/assets/imgs/' + item.imgNmae) +
            ')',
        } ])},
        item.isLast == true ? { mouseover: _vm.rightHover, mouseout: _vm.rightOut } : {}
      ),[_c('v-row',{staticStyle:{"height":"100%"},attrs:{"justify":"center","align":"center"}},[_c('v-col',{staticClass:"m",attrs:{"cols":"3"}},[_c('div',{staticClass:"titl ml-16 mt-n16 "},[_vm._v(_vm._s(item.title))]),_c('hr',{staticClass:"text-left"})]),_c('v-col',{staticClass:" ",attrs:{"cols":"8"}},[_c('div',{staticClass:"text  "},[_vm._v(_vm._s(item.text))])])],1)],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }